import React from "react";

const PagosIcon = () => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M16.666 3.33325H3.33268C2.40768 3.33325 1.67435 4.07492 1.67435 4.99992L1.66602 14.9999C1.66602 15.9249 2.40768 16.6666 3.33268 16.6666H16.666C17.591 16.6666 18.3327 15.9249 18.3327 14.9999V4.99992C18.3327 4.07492 17.591 3.33325 16.666 3.33325ZM3.33268 9.99992H16.666V6.66659H3.33268V9.99992Z" 
      //fill="#CDD0DC"
      fill="#30323A"
    />
  </svg>
);

export default PagosIcon;
